export function TimeInterval__Times(from: number, to: number, period: number) {
  const times: number[] = [];
  for (let time = from; time <= to; time += period) {
    times.push(time);
  }
  console.log("times ", times);
  return times;
}
